// extracted by mini-css-extract-plugin
export default {"primary_btn":"Button_primary_btn__MqDM0"};